module.exports = __webpack_public_path__ + "media/step_4_da.5207f711.mp3";